import { Stack } from 'component-library';

import { ConservationMethodology } from '@/api/rest/resources/conservation';
import { useProject } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useProject';

export const LegendScale = () => {
  const project = useProject().data;
  const isBUProject = project.natureUnitVariant === ConservationMethodology.bu;

  if (!isBUProject) {
    return (
      <Stack direction='row' className='justify-between w-full'>
        {[0.0, 0.2, 0.4, 0.6, 0.8, 1.0].map((num) => (
          <span key={num} className='typography-caption text-text-secondary'>
            {Intl.NumberFormat(window.navigator.language, {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1,
            }).format(num)}
          </span>
        ))}
      </Stack>
    );
  }

  return (
    <Stack direction='row' className='justify-between w-full'>
      {[0, 20, 40, 60, 80, 100].map((num) => (
        <span key={num} className='typography-caption text-text-secondary'>
          {Intl.NumberFormat(window.navigator.language).format(num)}
        </span>
      ))}
    </Stack>
  );
};
